const VERSION = '4.2.3';
export default VERSION;
